import AllEarsTitle from "@components/AllEarsTitle";
import Logo from "@components/ui/logo";
import { Trans, useLingui } from "@lingui/react/macro";
import { useSignupContext, useSignupRoutes } from "../context";
import { Redirect } from "react-router-dom";
import SignupImage from "@components/SignupImage";
import { MailCheckIcon } from "lucide-react";

export default function SignupConfirm() {
  const { t } = useLingui();

  // Context
  const { companyName, email } = useSignupContext();
  const signupRoutes = useSignupRoutes();

  // Return to index signup route if missing company name, email or search type
  if (!companyName || !email) {
    return <Redirect to={signupRoutes.SIGNUP} />;
  }

  return (
    <>
      <AllEarsTitle title={t`Bekräfta e-postadress`} />

      <div className="md:h-svh grid md:grid-cols-2">
        <div className="p-7 md:p-14 flex flex-col overflow-y-auto h-full">
          <Logo width={80} className="self-start" />

          <div className="w-full space-y-6 max-w-lg mx-auto flex-1 flex items-center justify-center">
            <div className="flex flex-col items-center text-balance gap-1.5">
              <MailCheckIcon className="w-6" />
              <h1 className="text-2xl font-semibold">
                <Trans>Pling! Du har mejl.</Trans>
              </h1>
              <p className="text-sm text-muted-foreground">
                <Trans>Kolla din inkorg för att verifiera ditt konto.</Trans>
              </p>
            </div>
          </div>
        </div>

        <SignupImage />
      </div>
    </>
  );
}
